/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_item = {
    readonly isCustomizable: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRequestHold_item" | "PdpSharedContactDealerButton_item" | "PdpSharedMakeOfferButton_item" | "PdpSharedContactSupportButton_item">;
    readonly " $refType": "PdpRespSidebarContact_item";
};
export type PdpRespSidebarContact_item$data = PdpRespSidebarContact_item;
export type PdpRespSidebarContact_item$key = {
    readonly " $data"?: PdpRespSidebarContact_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustomizable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestHold_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSupportButton_item",
      "args": null
    }
  ]
};
(node as any).hash = 'c6398452781e034901c582a7725f2e9b';
export default node;
